// The pallet check's look (the approved design: IBM Plex on a warm off-white, big touch targets).
// Inline styles are the house pattern; the shared values live here.

export const FONT = "'IBM Plex Sans', system-ui, -apple-system, 'Segoe UI', sans-serif";

export const C = Object.freeze({
  mono: "'IBM Plex Mono', ui-monospace, SFMono-Regular, Menlo, monospace",
  paper: '#F2F3EF',
  ink: '#15171A',
  sub: '#3A3F46',
  muted: '#4B5058',
  dim: '#C9CCD1',
  line: '#D5D8DC',
  night: '#0E1013',
  panel: '#1C1F24',
  steel: '#9BA3AE',
  track: '#E3E5E8',
  blue: '#1D4ED8',
  green: '#15803D',
  red: '#B91C1C',
  amber: '#F59E0B',
  woodA: '#C9A574',
  woodB: '#A9845A',
});

export const card = Object.freeze({
  background: '#FFFFFF', border: `1px solid ${C.line}`, borderRadius: 12, padding: 14,
});

export const sectionTitle = Object.freeze({ fontSize: 20, fontWeight: 700, margin: 0 });

export const chip = Object.freeze({
  fontSize: 13, fontWeight: 600, background: '#FFFFFF', border: `1px solid ${C.dim}`, borderRadius: 999, padding: '5px 11px',
});

export const wood = (stripe = 18, gap = 3) => `repeating-linear-gradient(90deg, ${C.woodA} 0px, ${C.woodA} ${stripe}px, ${C.woodB} ${stripe}px, ${C.woodB} ${stripe + gap}px)`;

export const tab = (on) => (on
  ? { minHeight: 44, borderRadius: 10, border: 0, background: '#FFFFFF', color: C.ink, fontFamily: 'inherit', fontSize: 14, fontWeight: 700, cursor: 'pointer' }
  : { minHeight: 44, borderRadius: 10, border: '1px solid #3D4148', background: C.panel, color: '#FFFFFF', fontFamily: 'inherit', fontSize: 14, fontWeight: 600, cursor: 'pointer' });

export const linkButton = Object.freeze({
  background: 'none', border: 0, padding: 0, color: C.blue, fontFamily: 'inherit', fontSize: 15, fontWeight: 600,
  cursor: 'pointer', textDecoration: 'underline', minHeight: 44,
});
